import {cleanCachedProfile, cleanTokens, setCachedProfile, setTokens} from '@/util/TokenStore';

const actions = {
    loginSuccess: (draft, {tokens, user, authorities}) => {
        draft.isLogin = true;
        draft.user = user;
        draft.authorities = authorities;

        setTokens(tokens);
        setCachedProfile({user, authorities});
    },

    reset: draft => {
        draft.isLogin = false;
        draft.user = null;
        draft.authorities = null;

        cleanTokens();
        cleanCachedProfile();
    },
};

export default actions;
